import { useAuth } from '@/hooks/useAuth';
import { AppRouters } from '@/utils/constants/routers';
import { useNavigate } from 'react-router-dom';
import { useEffect, ReactNode } from 'react';
import { UserRole } from '@/graphql/types/user';

const PrivateAdminRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!isAuthenticated && user?.role !== UserRole.ADMIN) {
        navigate(AppRouters.admin);
        return;
      }

      if (!isAuthenticated) {
        navigate(AppRouters.login);
        return;
      }

      if (user?.role !== UserRole.ADMIN) {
        navigate(-1);
        return;
      }
    }
  }, [isAuthenticated, loading, navigate, user]);

  if (loading) return null;
  if (!isAuthenticated) return null;
  if (user?.role !== UserRole.ADMIN) return null;

  return <>{children}</>;
};

const PublicAdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      if (user?.role === UserRole.ADMIN) {
        navigate(AppRouters.translatePanel);
      } else {
        navigate(-1);
      }
    }
  }, [isAuthenticated, loading, navigate, user]);

  if (loading) return null;

  if (isAuthenticated) return null;

  return <>{children}</>;
};

export { PrivateAdminRoute, PublicAdminRoute };
